import firebase from 'firebase/app';
import moment from 'moment';

const collName = 'audit';

const audit = {
    namespaced: true,
    state: {
        audit: [],
    },
    getters: {
        getaudit: (state) => {
            return state.audit;
        },

    },
    mutations: {
        SET_audit(state, audit) {
            state.audit = audit.slice().sort((a, b) => {
                return new Date(moment(b.date, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD HH:mm')) - new Date(moment(a.date, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD HH:mm'));

            });
        },
        ADD_audit(state, order) {
            state.audit.push(order);
        },
        UPDATE_ORDER(state, payload) {
            Object.assign(state.audit[payload.index], payload.order);
        },
        REMOVE_audit(state, order) {
            const index = state.audit.indexOf(order);
            state.audit.splice(index, 1);
        }
    },
    actions: {
        async loadaudit({ commit }) {
            let querySnapshot = await firebase.firestore().collection(collName).orderBy('date', 'desc').get();

            let order;
            let audit = querySnapshot.docs.map(function (doc) {
                order = doc.data();
                order.id = doc.id;
                return order;
            });
            commit('SET_audit', audit);
        },

    }
}

export default audit;